import { render, staticRenderFns } from "./TogglesField.vue?vue&type=template&id=2483ca3b&scoped=true&"
import script from "./TogglesField.vue?vue&type=script&lang=js&"
export * from "./TogglesField.vue?vue&type=script&lang=js&"
import style0 from "./TogglesField.vue?vue&type=style&index=0&id=2483ca3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483ca3b",
  null
  
)

export default component.exports